<template>
  <div id="bdm_seller_management" :class="isFull === 1 ? 'bdm_seller_management top_information1' : ' bdm_seller_management'">
    <van-nav-bar :title="$t('column.coin_seller_management')" placeholder fixed left-arrow >
        <template #left>
            <img src="../assets/img/bdm/bdm_left.png" alt="" height="20vw" @click="onClickLeft">
        </template>
        <template #right>
            <img src="../assets/img/bdm/lwchat_member_recharge_whatsapp.png" alt="" height="20vw" @click="onClickRight">
        </template>
    </van-nav-bar>
    <van-row>
      <van-col span="24">
         <van-tabs type="card" @click="onClick">
            <van-tab :title="$t('column.active_coin_seller')">
                <van-col span="24" class="bdm_seller_management_card_list">
                    <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="$t('other.there_is_no_more')"
                    :loading-text="$t('other.Loading')"
                    @load="onLoad"
                    >
                    <van-cell v-for="(item,i) in list" :key="i" class="custom-cell">
                        <van-col span="24">
                        <van-col span="24" class="card-item">
                            <van-col class="join-date">{{ $t('column.active') }}</van-col>
                            <van-row type="flex" align="center" class="user-info">
                            <van-col class="avatar-box">
                                <img :src="item.head_image" class="avatar" />
                            </van-col>
                            <van-col class="user-details">
                                <van-row type="flex" align="center" class="name-row">
                                <span class="name">{{ item.nick_name }}</span>
                                <img :src="item.country_img" v-if="item.country_img"/>
                                </van-row>
                                <van-row class="id-row">ID:{{ item.user_id }}</van-row>
                            </van-col>
                            </van-row>
                            <van-row type="flex" justify="space-between" class="stats-box">
                                <van-col class="stat-item stat-item1">
                                    <van-row class="stat-title">{{ $t('column.total_recharge') }}</van-row>
                                    <van-row type="flex" align="center" class="stat-value">
                                    <img src="../assets/img/coin5.png" class="stat-icon" />
                                    <span>{{ item.seller_coin }}</span>
                                    </van-row>
                                </van-col>
                                <van-col class="stat-item stat-item2">
                                    <van-row class="stat-title">{{ $t('column.this_month') }}</van-row>
                                    <van-row type="flex" align="center" class="stat-value">
                                    <img src="../assets/img/coin5.png" class="stat-icon" />
                                    <span>{{ item.month_coin }}</span>
                                    </van-row>
                                </van-col>
                                <van-col class="stat-item stat-item3">
                                    <van-row class="stat-title">{{ $t('column.last_month') }}</van-row>
                                    <van-row type="flex" align="center" class="stat-value">
                                    <img src="../assets/img/coin5.png" class="stat-icon" />
                                    <span>{{ item.last_month_coin }}</span>
                                    </van-row>
                                </van-col>
                            </van-row>
                        </van-col>
                        </van-col>
                    </van-cell>
                    </van-list>
                </van-col>
            </van-tab>
            <van-tab :title="$t('column.complete_recharge')">
                <van-col span="24" class="bdm_seller_management_card_list">
                    <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="$t('other.there_is_no_more')"
                    :loading-text="$t('other.Loading')"
                    @load="onLoad"
                    >
                    <van-cell v-for="(item,i) in list" :key="i" class="custom-cell">
                        <van-col span="24">
                            <van-col span="24" class="card-item">
                                <van-col class="join-date">{{  $t('column.complete') }}</van-col>
                                <van-row type="flex" align="center" class="user-info">
                                <van-col class="avatar-box">
                                    <img :src="item.head_image" class="avatar" />
                                </van-col>
                                <van-col class="user-details">
                                    <van-row type="flex" align="center" class="name-row">
                                    <span class="name">{{ item.nick_name }}</span>
                                    <img :src="item.country_img" v-if="item.country_img"/>
                                    </van-row>
                                    <van-row class="id-row">ID:{{ item.user_id }}</van-row>
                                </van-col>
                                </van-row>
                            </van-col>
                        </van-col>
                    </van-cell>
                    </van-list>
                </van-col>
            </van-tab>
            <van-tab :title="$t('column.pending_recharge')">
                <van-col span="24" class="bdm_seller_management_card_list">
                    <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="$t('other.there_is_no_more')"
                    :loading-text="$t('other.Loading')"
                    @load="onLoad"
                    >
                    <van-cell v-for="(item,i) in list" :key="i" class="custom-cell">
                        <van-col span="24">
                            <van-col span="24" class="card-item">
                                <van-col class="join-date">{{ $t('column.pending') }}</van-col>
                                <van-row type="flex" align="center" class="user-info">
                                <van-col class="avatar-box">
                                    <img :src="item.head_image" class="avatar" />
                                </van-col>
                                <van-col class="user-details">
                                    <van-row type="flex" align="center" class="name-row">
                                    <span class="name">{{ item.nick_name }}</span>
                                    <img :src="item.country_img" v-if="item.country_img"/>
                                    </van-row>
                                    <van-row class="id-row">ID:{{ item.user_id }}</van-row>
                                </van-col>
                                </van-row>
                            </van-col>
                        </van-col>
                    </van-cell>
                    </van-list>
                </van-col>
            </van-tab>
        </van-tabs>
      </van-col>
      <van-overlay :show="loading1" z-index="2003">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'
import {judgeIosAndroid} from "../assets/js/models"

export default {
  data:function() {
    return {
      list: [],
      loading: false,
      loading1: false,
      finished: false,
      page: 1,
      type: 1,
      whats_app: undefined,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  methods: {
    onClickRight() {
      console.log(this.whats_app)
      // 拦截官方联系方式 whats_app
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          window.webkit.messageHandlers.jump_url.postMessage(this.whats_app)
        } else {
          window.AndroidJs.jump_url(this.whats_app)
        }
    },
    onLoad() {
      if (this.page > 1){
        this.get_list()
      }
    },
    onClick(name, title) {
      if (this.loading) {
        return;
      }
      let newType = name + 1;
      if (this.type !== newType) {
        this.type = newType;
        this.page = 1;
        this.finished = false;
        this.list = [];
        this.loading1 = true;
        this.get_list();
      }
    },
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1)
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      if (this.page === 1) {
        this.list = []
      }
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=seller_management",{ 
        params:{
          token: token,
          type: this.type,
          page: this.page
        }
      }).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
          this.loading1 = false
        if(res.data.status===1){
          for (let j = 0; j < res.data.data.list.length; j++) {
            this.list.push(res.data.data.list[j])
          }
          this.whats_app = res.data.data.whats_app
          //如果列表数据条数< 0，不再触发滚动加载
          if (res.data.data.list.length <= 0) {
            this.finished = true
          }else{
            this.finished = false
          }
          this.page ++
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast(res.data.error);
        }
      }).catch(err => {
        this.loading = false
        this.loading1 = false
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bdm_seller_management.vue